import { DialogContent } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import { useDialog } from "./DialogProvider";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    textAlign: "center",
  },
}));

function DialogImage(props) {
  const classes = useStyles();
  const [, closeDialog] = useDialog();

  return (
    <>
      <DialogContent
        onClick={() => {
          closeDialog();
        }}
        classes={{ root: classes.root }}
      >
        <img style={{ objectFit: "fit", width: "100%", height: "100%" }} src={props.imageUrl} alt="" />
        {props.children}
      </DialogContent>
    </>
  );
}

DialogImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};

export default DialogImage;
